import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { hedefUnvan } from '../utils/hedef';
import { setBranch } from '../services/api';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    const token = params.get('token');
    const userStr = params.get('user');
    const error = params.get('error');

    if (error) {
      navigate('/login?error=' + encodeURIComponent(error));
      return;
    }
    if (token && userStr) {
      try {
        const user = JSON.parse(decodeURIComponent(userStr));
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        setBranch('all');   // yeni sessiya bütün kampuslarla başlayır
        // Girişdən əvvəl açmaq istədiyi sənədə qayıdırıq (varsa)
        window.location.replace(hedefUnvan());
      } catch {
        navigate('/login?error=' + encodeURIComponent(t('authCallback.error')));
      }
    } else {
      navigate('/login');
    }
  }, []);

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', flexDirection:'column', gap:16 }}>
      <div style={{ width:40, height:40, border:'3px solid #007c82', borderTopColor:'transparent', borderRadius:'50%', animation:'spin 0.8s linear infinite' }}></div>
      <p style={{ color:'#666' }}>{t('authCallback.checking')}</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  );
}
